
import React from 'react';
import { CommonModule, UCAModule } from "uca-react-containers-library";

const CheckTextMessageComponent = () => {
    return (
        <CommonModule.ViewportProvider>
            <UCAModule.CheckTextMessage />
        </CommonModule.ViewportProvider>
    );
};

export default CheckTextMessageComponent;
